<!-- components/wallet/TransactionsOverview.vue -->
<template>
  <div class="overview-section">
    <b-container fluid="xl">
      <h3 class="title mb-4">Overview</h3>

      <b-row class="justify-content-md-center">
        <b-col cols="12" md="6" xl="4" class="mb-4" v-for="(item, index) in stats" :key="index">
          <b-card no-body class="flex-column flex-column-reverse flex-md-row align-top">
            <div
              class="d-flex flex-column justify-content-center justify-content-sm-start text-center text-md-left flex-grow-1">
              <span class="text-muted">{{ item.label }}</span>
              <h3 class="card-heading">
                <span>{{ item.value }}</span>
                <span class="text-secondary" v-if="item.unit">{{ item.unit }}</span>
              </h3>
              <small class="text-muted">{{ item.subtext }}</small>
            </div>

            <div class="icon-circle flex-shrink-0 mx-auto ml-sm-auto">
              <img :src="item.icon" :alt="item.label" />
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "TransactionsOverview",
  props: {
    stats: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.overview-section {
  background-color: #E2E6EB;
  padding: 3rem 0;
}

.overview-section .container-xl {
  margin: 0 auto;
  max-width: 1750px;
  padding: 0 4%;
}

.overview-section .title {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 30px;
}

.card {
  border-radius: 0;
  box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.05);
  font-size: 1rem;
  padding: 2rem;
}

.card-heading {
  align-items: center;
  display: inline-flex;
  font-size: 32px;
  font-weight: 700;
  gap: 0.25rem;
  line-height: 30px;
  margin: 1rem 0;
}

.text-center {
  margin: 0;
}

.text-muted {
  color: #9E9E9E !important;
}

.icon-circle {
  align-items: center;
  background-color: #E2E6EB !important;
  border-radius: 50%;
  display: flex;
  height: 64px;
  justify-content: center;
  width: 64px;
}

.icon-circle img {
  max-height: 32px;
  max-width: 32px;
}

@media (max-width: 768px) {
  .card-heading {
    justify-content: center;
  }

  .icon-circle {
    margin-bottom: 1rem;
  }
}
</style>
